import { HTTPURL } from "../constants/Matcher";

// Public endpoint, no auth required.
// level: 'senior' (Year 11-12) | 'high' | 'primary' | undefined (no filter, returns all active)
export async function get_public_branches(level) {
  try {
    const url =
      `${HTTPURL}api/public/branches` + (level ? `?level=${level}` : "");
    const res = await fetch(url);
    const json = await res.json();
    return json?.data || [];
  } catch (e) {
    console.error("get_public_branches failed:", e);
    return [];
  }
}

// Each course's timetable is whatever classes the branches have created for
// it — there is no separate document to publish.
export async function get_course_timetable(slug, year) {
  try {
    const res = await fetch(
      `${HTTPURL}api/public/timetable?slug=${encodeURIComponent(slug)}&year=${year}`
    );
    const json = await res.json();
    return json?.data || null;
  } catch (e) {
    console.error("get_course_timetable failed:", e);
    return null;
  }
}

// One campus's page: its details and its timetable for this term (and next
// term once the campus has timetabled it). campus is the slug from
// get_public_branches (or a branch id). null when the campus is not found.
export async function get_campus_timetable(campus) {
  try {
    const res = await fetch(
      `${HTTPURL}api/public/campus-timetable?campus=${encodeURIComponent(campus)}`
    );
    const json = await res.json();
    return json?.status ? json.data : null;
  } catch (e) {
    console.error("get_campus_timetable failed:", e);
    return null;
  }
}

// Address of a campus page. The API sends `slug`; the home page's offline
// fallback list does not, so it is worked out from the name the same way.
export const campusPath = (b) =>
  `/campuses/${
    b?.slug ||
    String(b?.name || "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  }`;

// Which part of the school year it is: { key: "t4" | "summer" | ..., label,
// upcoming }. null when it cannot be found; callers then show everything.
export async function get_current_period() {
  try {
    const res = await fetch(`${HTTPURL}api/public/current-period`);
    const json = await res.json();
    return json?.data || null;
  } catch (e) {
    console.error("get_current_period failed:", e);
    return null;
  }
}
